<template>
  <transition name="fade">
    <div class="theme-preview-container">
      <div class="toolbar">
        <div class="theme-preview-toolbar-inner">
          <div class="section-left">
            <md-button class="md-dense md-accent md-raised md-primary bn-baseline btn-preview-back" @click="closeModal">
              <md-icon class="">chevron_left</md-icon> BACK
            </md-button>
          </div>
          <div class="section-center"></div>
          <div class="section-right">
            <md-button class="md-icon-button btn-viewport" data-viewmode="phone_portrait" @click="setViewPort('phone_portrait')">
              <md-icon>phone_iphone</md-icon>
            </md-button>
            <md-button class="md-icon-button btn-viewport" data-viewmode="tablet_portrait" @click="setViewPort('tablet_portrait')">
              <md-icon>tablet_mac</md-icon>
            </md-button>
            <md-button class="md-icon-button btn-viewport" data-viewmode="desktop" @click="setViewPort('desktop')">
              <md-icon>desktop_windows</md-icon>
            </md-button>
            <md-button class="md-dense md-accent md-raised md-primary btn-createsite" @click="createSite">
              CREATE SITE
            </md-button>
          </div>
        </div>
      </div>
      <div class="preview-frame dynamic-height">
        <iframe
          title="Template Preview"
          allowfullscreen
          class="theme-preview-iframe"
          :class="iframeViewportClass"
          :src="getPreviewUrl()"
          :data-viewport="viewPort"
        ></iframe>
      </div>
    </div>
  </transition>
</template>
<script>
// Side-effect import: required for Webpack to emit CSS in the same way as themes-garden /
// shared-header. Relying only on SFC <style> was unreliable after the Webpack 5 + extract pipeline.
import style from 'styles/theme-preview-modal.scss'

export default {
  props: {
    id: Number,
    name: String,
    previewUrl: String,
  },

  data: () => ({
    viewPort: 'desktop',
    previewToolbarHeight: 0,
  }),
  computed: {
    iframeViewportClass() {
      const v = this.viewPort || 'desktop'
      return `theme-preview-iframe--${v}`
    },
  },
  methods: {
    closeModal: function () {
      this.$store.dispatch('popModal')
    },
    createSite() {
      this.$router.push({ path: `/register`, query: { template_id: this.id } })
      this.closeModal()
    },
    getPreviewUrl: function () {
      return this.previewUrl
    },
    setViewPort(viewport) {
      this.viewPort = viewport
    },
    getViewPort() {
      return this.viewPort
    },
  },
  mounted() {
    if (!this.viewPort) {
      this.viewPort = 'desktop'
    }
  },
  beforeDestroy() {
  },
}
</script>
